import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import Divider from '../../components/Divider/Divider'

type Props = {
  onLoginClick: () => void
}
export default function SignUpOrLogin({ onLoginClick }: Props) {
  return (
    <div className="mx-auto max-w-480 text-center lg:px-64">
      <Link to="/gympass/signup/" className="c-button c-button--choice w-full">
        <span>
          <span className="c-button--choice-small-text">
            <FormattedMessage
              id="Redeem.login.notAUser"
              defaultMessage="Not a Lifesum user?"
            />
          </span>
          <FormattedMessage
            id="Header.menuBar.signUp"
            defaultMessage="Sign up"
          />
        </span>
      </Link>
      <div className="my-32">
        <Divider light={true} />
      </div>
      <button
        className="c-button c-button--choice w-full"
        onClick={onLoginClick}
      >
        <span>
          <span className="c-button--choice-small-text">
            <FormattedMessage
              id="gympass_log_in_question"
              defaultMessage="Already have a Lifesum account?"
            />
          </span>
          <FormattedMessage id="general.log_in" defaultMessage="Log in" />
        </span>
      </button>
    </div>
  )
}
